import { memo, useCallback, useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Image from "../Image"
import Icon from "../Icon"
import { ICON } from "../Icon/data"
import Button from "../Button"

import './index.scss'

type ImageAlt = {
  url: string
  alt: string
}

type ImageGallery = {
  values: string[] | ImageAlt[]
}

const ImageGallery = memo(({ values }: ImageGallery) => {
  const { t } = useTranslation()

  const [index, setIndex] = useState<number>(0)

  useEffect(() => {
    setIndex(0) // Make sure the index goes back on value change
  }, [values])

  const switchImage = useCallback((offset: number) => {
    let newIndex = index + offset
    if (newIndex >= values.length) newIndex = 0
    else if (newIndex < 0) newIndex = values.length - 1
    setIndex(newIndex)
  }, [index])

  return (
    <div className="ImageGallery">
      <Image
        url={values[index]?.url ?? values[index]}
        alt={values[index]?.alt ?? t('None')}
      />
      {values.length > 1 && (
        <div className="ImageGallery__flip">
          <Button
            label={<Icon icon={ICON.CHEVRON_LEFT} />}
            onClick={() => switchImage(-1)}
            type='ghost'
          />
          <Button
            label={<Icon icon={ICON.CHEVRON_RIGHT} />}
            onClick={() => switchImage(1)}
            type='ghost'
          />
        </div>
      )}
    </div>
  )
})

export default ImageGallery
